import { VaroCategories } from 'shared/analytics/types/categories';

export const VaroSubCategories = {
  APPLICATION: {
    CHECKING: 'checking',
    SAVINGS: 'savings',
    BELIEVE: 'believe',
  },
  CARD: {
    WALLET_PROVISIONING: 'wallet_provisioning',
    REPLACEMENT_CARD: 'replacement_card',
    CARD_ACTIVATION: 'card_activation',
  },
  DCF: {
    DCF: 'dcf',
    DCF_BELIEVE_DAY_0_APPLICATION: 'dcf_believe_day_0_application',
  },
  DIRECT_DEPOSIT: {
    DEPOSIT_TRACKER: 'deposit_tracker',
    INCENTIVE: 'incentive',
    INSTANT_SWITCH: 'instant_switch',
  },
  LOGIN: {
    FORGOT_PASSWORD: 'forgot_password',
  },
  ONBOARDING: {
    ONBOARDING_WIZARD: 'onboarding_wizard',
    ONBOARDING_NURTURE: 'onboarding_nurture',
    ONBOARDING_CHECKLIST: 'onboarding_checklist',
  },
  REWARDS: {
    CASHBACK: 'cashback',
    PARTNERSHIP_OFFERS: 'partnership_offers',
  },
  SAVINGS: {
    SAVINGS_HIGH_APY: 'savings_high_apy',
  },
  SERVICING: {
    DISPUTE: 'dispute',
    CHAT: 'chat',
    WALLET_PROVISIONING: 'wallet_provisioning',
  },
  SETTINGS: {
    NOTIFICATIONS: 'notifications',
  },
  V2A: {
    TRANSFER_MONEY_V2A_SENDER: 'transfer_money_v2a_sender',
    TRANSFER_MONEY_V2A_RECEIVER: 'transfer_money_v2a_receiver',
  },
  VARO_ADVANCE: {
    VA_HOME_TILE: 'va_home_tile',
    VA_APPLICATION: 'va_application',
    VA_DISBURSEMENT: 'va_disbursement',
    VA_REPAYMENT: 'va_repayment',
    VA_INTRO: 'va_intro',
    TAKE_OUT_VA: 'take_out_va',
    VA_DAY_0: 'va_day_0',
  },
  VARO_BELIEVE: {
    MOVE_YOUR_PAY: 'move_your_pay',
    BELIEVE_APPLICATION: 'believe_application',
    BELIEVE_MANAGEMENT: 'believe_management',
    BELIEVE_INTRO: 'believe_intro',
    BELIEVE_DISBURSEMENT: 'believe_disbursement',
  },
  VLOC: {
    VLOC_APPLICATION: 'vloc_application',
    VLOC_REPAYMENT: 'vloc_repayment',
    VLOC_WAITLIST: 'vloc_waitlist',
    VLOC_HOME_TILE: 'vloc_home_tile',
    TAKE_OUT_VLOC: 'take_out_vloc',
  },
} as const satisfies Partial<
  Record<keyof typeof VaroCategories, Record<string, string>>
>;

type SubCategoriesByCategory = {
  [K in keyof typeof VaroCategories as (typeof VaroCategories)[K]]: K extends keyof typeof VaroSubCategories
    ? (typeof VaroSubCategories)[K][keyof (typeof VaroSubCategories)[K]]
    : never;
};

/** Sub-categories valid for a given category. `never` for categories that have none. */
export type VaroSubCategoryFor<TCategory extends VaroCategories> =
  SubCategoriesByCategory[TCategory];

export type VaroEventSubCategories = VaroSubCategoryFor<VaroCategories>;
